import {HttpClient, HttpContext} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, map} from 'rxjs';
import {
  NotificationChannelSettings,
  UpdateUserSettingsPayload,
  UserSetting,
  defaultNotificationChannelSettings,
  notificationSettingsFromUserSettings,
  userSettingsFromNotificationSettings,
} from '@gatewee/types/user-setting';
import {SKIP_SPINNER} from './tokens/spinner.token';

@Injectable({
  providedIn: 'root',
})
export class ProfileSettingsService {
  constructor(private readonly http: HttpClient) {}

  getSettings(): Observable<UserSetting[]> {
    return this.http
      .get<UserSetting[] | UpdateUserSettingsPayload>(
        '/auth/profile/settings',
        {
          context: new HttpContext().set(SKIP_SPINNER, true),
        },
      )
      .pipe(map(response => this.normalizeSettingsResponse(response)));
  }

  updateSettings(settings: UserSetting[]): Observable<UserSetting[]> {
    return this.http
      .patch<UserSetting[] | UpdateUserSettingsPayload>(
        '/auth/profile/settings',
        {settings} satisfies UpdateUserSettingsPayload,
        {
          context: new HttpContext().set(SKIP_SPINNER, true),
        },
      )
      .pipe(map(response => this.normalizeSettingsResponse(response)));
  }

  getNotificationSettings(): Observable<NotificationChannelSettings> {
    return this.getSettings().pipe(
      map(settings => notificationSettingsFromUserSettings(settings)),
    );
  }

  saveNotificationSettings(
    settings: NotificationChannelSettings,
  ): Observable<NotificationChannelSettings> {
    return this.updateSettings(
      userSettingsFromNotificationSettings(settings),
    ).pipe(
      map(updated => notificationSettingsFromUserSettings(updated, settings)),
    );
  }

  getDefaultNotificationSettings(): NotificationChannelSettings {
    return {...defaultNotificationChannelSettings};
  }

  private normalizeSettingsResponse(
    response: UserSetting[] | UpdateUserSettingsPayload,
  ): UserSetting[] {
    if (Array.isArray(response)) {
      return response;
    }

    return response.settings ?? [];
  }
}
